var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"margin-top":"-150px"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"137","height":"230","viewBox":"0 0 137 100"}},[_c('text',{attrs:{"id":"_","data-name":"—","font-size":"100","font-family":"Timberline-Regular, Timberline","letter-spacing":"0.05em"}},[_c('tspan',{attrs:{"x":"0","y":"150"}},[_vm._v("—")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }